import { cacheKeys } from "@constants/cache-keys";
import { isScreenshotMode } from "@constants/common";
import { mockedUserLeaderboard } from "@constants/mocked-data";
import { useExamContext } from "@features/exam/contexts/ExamContext";
import useAuthUser from "@hooks/useAuthUser";
import type { LeaderboardTimePeriod } from "@memorang/ui/components/Leaderboard/types";
import { useQuery } from "@tanstack/react-query";
import { fetchUserRank } from "../api/queries";

type Options = {
	timePeriod: LeaderboardTimePeriod;
};

export const useUserLeaderboard = ({ timePeriod }: Options) => {
	const { userPublicMetadataId } = useAuthUser();

	const {
		currentExamContext: { projectId, organizationId },
	} = useExamContext();

	return useQuery({
		queryKey: [
			cacheKeys.userLeaderboard,
			projectId,
			organizationId,
			userPublicMetadataId,
			timePeriod,
		],
		queryFn: async () => {
			const item = isScreenshotMode
				? mockedUserLeaderboard
				: await fetchUserRank({
						periodType: timePeriod,
						projectId,
						organizationId,
						userPublicMetadataId: userPublicMetadataId!,
					});
			return {
				...item,
				rank: Number(item.rank),
			};
		},
		enabled: !!projectId && !!organizationId && !!userPublicMetadataId,
	});
};
